"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ValidityVote = exports.ValidityAttestation = exports.ImplicitCandidateSignature = exports.ExplicitCandidateSignature = exports.AvailabilityVote = exports.CandidateReceipt = exports.HeadData = exports.EgressQueueRoot = exports.BalanceUpload = exports.CandidateSignature = void 0;

var _util = require("@plugnet/util");

var _EnumType = _interopRequireDefault(require("../codec/EnumType"));

var _Struct = _interopRequireDefault(require("../codec/Struct"));

var _Tuple = _interopRequireDefault(require("../codec/Tuple"));

var _Vector = _interopRequireDefault(require("../codec/Vector"));

var _Bytes = _interopRequireDefault(require("../primitive/Bytes"));

var _Null = _interopRequireDefault(require("../primitive/Null"));

var _U = _interopRequireDefault(require("../primitive/U64"));

var _AccountId = _interopRequireDefault(require("./AccountId"));

var _Hash = _interopRequireDefault(require("./Hash"));

var _ParaId = _interopRequireDefault(require("./ParaId"));

var _Signature = _interopRequireDefault(require("./Signature"));

var _SessionKey = _interopRequireDefault(require("./SessionKey"));

// Copyright 2017-2019 @polkadot/types authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
class CandidateSignature extends _Signature.default {}

exports.CandidateSignature = CandidateSignature;

class BalanceUpload extends _Tuple.default.with({
  AccountId: _AccountId.default,
  U64: _U.default
}) {}

exports.BalanceUpload = BalanceUpload;

class EgressQueueRoot extends _Tuple.default.with({
  ParaId: _ParaId.default,
  Hash: _Hash.default
}) {}

exports.EgressQueueRoot = EgressQueueRoot;

class HeadData extends _Bytes.default {}

exports.HeadData = HeadData;

class CandidateReceipt extends _Struct.default {
  constructor(value) {
    super({
      parachainIndex: _ParaId.default,
      collator: _AccountId.default,
      signature: CandidateSignature,
      headData: HeadData,
      balanceUploads: _Vector.default.with(BalanceUpload),
      egressQueueRoots: _Vector.default.with(EgressQueueRoot),
      fees: _U.default,
      blockDataHash: _Hash.default
    }, value);
  }

}

exports.CandidateReceipt = CandidateReceipt;

class AvailabilityVote extends _Tuple.default.with({
  SessionKey: _SessionKey.default,
  CandidateSignature
}) {}

exports.AvailabilityVote = AvailabilityVote;

class ExplicitCandidateSignature extends CandidateSignature {}

exports.ExplicitCandidateSignature = ExplicitCandidateSignature;

class ImplicitCandidateSignature extends CandidateSignature {}

exports.ImplicitCandidateSignature = ImplicitCandidateSignature;

class ValidityAttestation extends _EnumType.default {
  constructor(value) {
    super({
      // This Null is not in the original, however indexes start at 1, so add a
      // placeholder in the first position (which is basically non-valid)
      Null: _Null.default,
      ImplicitCandidateSignature,
      // 1
      ExplicitCandidateSignature // 2

    }, value);
  }
  /**
   * @description Returns the item as a [[ExplicitCandidateSignature]]
   */


  get asExplicitCandidateSignature() {
    (0, _util.assert)(this.toNumber() === 2, "Cannot convert '".concat(this.type, "' via asExplicitCandidateSignature"));
    return this.value;
  }
  /**
   * @description Returns the item as a [[ImplicitCandidateSignature]]
   */


  get asImplicitCandidateSignature() {
    (0, _util.assert)(this.toNumber() === 1, "Cannot convert '".concat(this.type, "' via asImplicitCandidateSignature"));
    return this.value;
  }

}

exports.ValidityAttestation = ValidityAttestation;

class ValidityVote extends _Tuple.default.with({
  SessionKey: _SessionKey.default,
  ValidityAttestation
}) {}
/**
 * @name AttestedCandidate
 * @description
 *  An attested candidate
 */


exports.ValidityVote = ValidityVote;

class AttestedCandidate extends _Struct.default {
  constructor(value) {
    super({
      candidate: CandidateReceipt,
      validityVotes: _Vector.default.with(ValidityVote),
      availabilityVotes: _Vector.default.with(AvailabilityVote)
    }, value);
  }

}

exports.default = AttestedCandidate;